"use client";

import * as React from "react";
import MonarchResolver from "@/monarch/MonarchResolver";
import { ResourcePageSideRailTestResult } from "@/monarch/rules/resourcePageSideRail/types";

type SideRailClientProps = {
  controlVariant: React.ReactNode;
  siderailVariant: React.ReactNode;
};

export default function SideRailClient({
  controlVariant,
  siderailVariant,
}: SideRailClientProps) {
  return (
    <MonarchResolver<ResourcePageSideRailTestResult>
      experimentKey="useResourcePageSideRail"
      variants={{
        control: controlVariant,
        siderail: siderailVariant,
      }}
      fallbackVariant="control"
    />
  );
}
